import React from 'react';
import { Button } from '../ui';

/** @deprecated Use `<Button variant="destructive" />` from `../ui`. */
const ErrorContainedButton = React.forwardRef(function ErrorContainedButton(props, ref) {
  return <Button ref={ref} variant="destructive" {...props} />;
});

export default ErrorContainedButton;
